<div class="account-details-row">
    <span *ngIf="inTheGame" class="pill pill-left pill-blue">
        <img src="../../assets/icons/points-icon.svg" />
        <span class="pill-number">{{ xp }} XP</span>
    </span>

    <span class="menu-account-icon">
        <img *ngIf="authService.photoUrl; else initials" [src]="authService.photoUrl" alt="User photo" class="account-photo" />
        <ng-template #initials>
            <span class="inner-circle">
                {{ buyer?.employee?.userName ? getInitial(buyer.employee.userName) : '' }}
            </span>
        </ng-template>
    </span>

    <span *ngIf="inTheGame" class="pill pill-right pill-purple">
        <span class="pill-number">{{ lengthOfService }}</span>
        <img src="../../assets/icons/clock-icon.svg" />
    </span>
</div>
<div class="user-name-container">
    <span>{{buyer?.employee?.forename || '' }} {{ buyer?.employee?.surname || ''}}</span>
</div>
<div class="user-role">
    <span>{{jobTitle | async}}</span>
</div>
<div class="user-email">
    <span>{{email}}</span>
</div>
<div class="user-region" [hidden]="isNotInRegion">
    <span>{{regionName$ | async}} <span class="label">(Region)</span></span>
</div>
<div class="user-branch">
    <span *ngIf="!isNotInBranch">{{branchName}} <span class="label">(Branch)</span></span>
    <span *ngIf="isNotInBranch">Not in branch</span>
</div>